export default "__VITE_ASSET__CFYxosNz__"